(function() {
  const initSubWidget = () => {
    const widgets = document.querySelectorAll('.product-sub-widget');
    
    widgets.forEach(widget => {
      const sectionId = widget.dataset.sectionId;
      const productId = widget.dataset.productId;
      const variants = JSON.parse(widget.dataset.variants);
      
      const tiers = widget.querySelectorAll('.sub-widget__tier');
      const options = widget.querySelectorAll('.sub-widget__option');
      const freqSelect = widget.querySelector('.js-frequency-select');
      const sellingPlanInput = widget.querySelector('.js-selling-plan-input');
      
      // UI Elements to update
      const strikePriceElem = widget.querySelector('.js-strike-price');
      const currentPriceElem = widget.querySelector('.js-widget-current-price');
      const onetimePriceElem = widget.querySelector('.js-onetime-price');
      const saveBadgeElem = widget.querySelector('.js-save-badge');
      const perDayElem = widget.querySelector('.js-per-day');
      const perRefillElem = widget.querySelector('.js-per-refill');
      const summaryRefillElem = widget.querySelector('.js-summary-refill');
      const summaryDayElem = widget.querySelector('.js-summary-day');
      const summaryDaysTextElem = widget.querySelector('.js-summary-days');
      const refillCountElems = widget.querySelectorAll('.js-refill-count');
      const installmentElem = widget.querySelector('.js-installment-price');
      const shippingTextElem = widget.querySelector('.js-shipping-text');
      
      // Global ATC Button (linked to this product section)
      const productSection = widget.closest('[data-section-type="product"]') || document.body;
      const atcButton = productSection.querySelector('[name="add"]');
      const atcPriceBtn = productSection.querySelector('.product-price-btn');

      const formatMoney = (cents) => {
        const format = window.moneyFormat || "${{amount}}";
        const value = (cents / 100).toFixed(2);
        return format.replace('{{amount}}', value);
      };

      const updateWidgetData = () => {
        const activeTier = widget.querySelector('.sub-widget__tier.is-active');
        const activeOption = widget.querySelector('.sub-widget__option.is-selected');

        // For single-variant (no-variation) products the tier chips are hidden.
        // Derive all data from the first (only) variant instead.
        const noTierMode = !activeTier;
        const variantId = noTierMode
          ? String(variants[0]?.id || '')
          : activeTier.dataset.variantId;
        const variant = variants.find(v => String(v.id) === variantId) || variants[0];

        // Refill / days: use tier data when available, fall back to sensible defaults
        const rawRefills = noTierMode ? '1' : (activeTier.dataset.refills || '2');
        const refillMatch = rawRefills.match(/\d+/);
        const refillCount = refillMatch ? parseInt(refillMatch[0]) : 1;
        const daysCount = noTierMode ? 30 : (parseInt(activeTier.dataset.days) || 60);
        const diffusersCount = noTierMode ? 1 : (parseInt(activeTier.dataset.diffusers) || 1);
        const anchorPriceData = noTierMode
          ? (variant.compare_at_price || variant.price)
          : (parseFloat(activeTier.dataset.anchorPrice) || variant.price);

        const selectedFreqOption = freqSelect?.options[freqSelect.selectedIndex];
        const sellingPlanDiscount = parseFloat(selectedFreqOption?.dataset.discount) || 0;
        const bundleSaveVal = noTierMode ? 0 : (activeTier.dataset.bundleSave ? parseFloat(activeTier.dataset.bundleSave.replace('%', '')) : 0);
        const savePercent = sellingPlanDiscount > 0 ? sellingPlanDiscount : (bundleSaveVal || 10);

        const quantityInput = productSection.querySelector('input[name="quantity"]');
        const quantity = parseInt(quantityInput?.value || 1);
        const isSubscription = activeOption?.dataset.type === 'subscription';

        // Update Selling Plan Input
        if (isSubscription && freqSelect) {
          sellingPlanInput.value = freqSelect.value;
          sellingPlanInput.removeAttribute('disabled');
        } else {
          sellingPlanInput.value = "";
          sellingPlanInput.setAttribute('disabled', 'disabled');
        }

        // Update Upsell Cards
        const upsellCards = productSection.querySelectorAll('.js-upsell-card');
        upsellCards.forEach(card => {
          if (isSubscription) {
            card.classList.add('is-subscriber');
          } else {
            card.classList.remove('is-subscriber');
          }
        });

        // Sync with Main Variant Picker (if exists)
        const targetRadio = productSection.querySelector(`input[name="id"][value="${variantId}"]`);
        if (targetRadio && !targetRadio.checked) {
          targetRadio.checked = true;
          targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // Update classes on main variant chips
        const mainVariantChips = productSection.querySelectorAll('.variant-card.variant-chip, .variant-option-item');
        mainVariantChips.forEach(chip => {
          const chipId = chip.dataset.variantId || chip.querySelector('input')?.value;
          if (chipId == variantId) {
            chip.classList.add('selected');
            chip.classList.add('is-active');
          } else {
            chip.classList.remove('selected');
            chip.classList.remove('is-active');
          }
        });

        // Sync image gallery
        const imageIndex = noTierMode ? 0 : activeTier.dataset.imageIndex;
        if (imageIndex !== undefined) {
          const productSlider = document.querySelector('.product-main-slider');
          if (productSlider && productSlider.swiper) {
            productSlider.swiper.slideTo(parseInt(imageIndex));
          }
        }

        if (sellingPlanInput) {
          sellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // Calculate Prices
        const basePrice = variant.price;

        let subDiscount = 10;
        const allFreqOptions = freqSelect ? Array.from(freqSelect.options) : [];
        const foundPlanDiscount = allFreqOptions.map(o => parseFloat(o.dataset.discount) || 0).find(d => d > 0);

        if (sellingPlanDiscount > 0) {
          subDiscount = sellingPlanDiscount;
        } else if (foundPlanDiscount > 0) {
          subDiscount = foundPlanDiscount;
        } else {
          subDiscount = 0;
        }

        const discountedPrice = Math.round(basePrice * (1 - (subDiscount / 100)));
        const finalPricePerUnit = isSubscription ? discountedPrice : basePrice;
        const finalPrice = finalPricePerUnit * quantity;

        // Update UI
        const anchorPrice = anchorPriceData;

        if (strikePriceElem) strikePriceElem.innerText = formatMoney(anchorPrice);
        if (currentPriceElem) currentPriceElem.innerText = formatMoney(isSubscription ? discountedPrice : basePrice);
        if (onetimePriceElem) onetimePriceElem.innerText = formatMoney(basePrice);

        const savingsAmount = isSubscription ? (anchorPrice - discountedPrice) : (anchorPrice - basePrice);
        if (saveBadgeElem) {
           saveBadgeElem.innerText = `Save ${formatMoney(savingsAmount)}`;
           saveBadgeElem.style.display = savingsAmount > 0 ? 'inline-block' : 'none';
        }

        const compareElem = productSection.querySelector('.js-compare-price');
        if (compareElem) {
          compareElem.innerHTML = formatMoney(anchorPrice * quantity);
          compareElem.style.display = anchorPrice > (isSubscription ? discountedPrice : basePrice) ? 'inline-block' : 'none';
        }

        const pricePerRefill = finalPricePerUnit / Math.max(refillCount, 1);
        const pricePerDay = finalPricePerUnit / Math.max(daysCount, 1);

        if (perRefillElem) perRefillElem.innerText = formatMoney(pricePerRefill);
        if (perDayElem) perDayElem.innerText = formatMoney(pricePerDay);
        if (summaryRefillElem) summaryRefillElem.innerText = formatMoney(pricePerRefill);
        if (summaryDayElem) summaryDayElem.innerText = formatMoney(pricePerDay);
        if (summaryDaysTextElem) summaryDaysTextElem.innerText = `${daysCount} days`;

        refillCountElems.forEach(el => el.innerText = refillCount);

        if (shippingTextElem) {
          if (finalPrice >= 4900) {
            shippingTextElem.innerText = 'Free US shipping';
          } else {
            shippingTextElem.innerText = 'Fast shipping';
          }
        }

        // Update Feature Bar
        const featureDaysElem = widget.querySelector('.js-feature-days');
        const featureRoomsElem = widget.querySelector('.js-feature-rooms');
        const featureIconRoomsElem = widget.querySelector('.js-feature-icon-rooms');

        if (featureDaysElem) featureDaysElem.innerText = `${daysCount} days of calm`;
        if (featureRoomsElem) featureRoomsElem.innerText = `${diffusersCount} ${diffusersCount > 1 ? 'rooms' : 'room'} covered`;

        if (featureIconRoomsElem) {
          const homeIcon = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 2.5L3.33333 7.5V17.5H16.6667V7.5L10 2.5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
          featureIconRoomsElem.innerHTML = Array(diffusersCount).fill(homeIcon).join('');
        }

        // Update Tier Badges (only when tiers are visible)
        if (!noTierMode) {
          const allTiers = widget.querySelectorAll('.sub-widget__tier');
          allTiers.forEach(tier => {
            const badge = tier.querySelector('.js-tier-badge');
            if (!badge) return;
            const anchor = parseFloat(tier.dataset.anchorPrice);
            const oneTime = parseFloat(tier.dataset.oneTimePrice);
            if (anchor > oneTime) {
              const savePct = Math.round((anchor - oneTime) / anchor * 100);
              badge.innerText = savePct > 0 ? `Save ${savePct}%` : '';
              badge.style.display = savePct > 0 ? 'block' : 'none';
            } else {
              badge.style.display = 'none';
            }
          });
        }

        if (installmentElem) installmentElem.innerText = formatMoney(finalPrice / 4);

        // Update ATC Button
        if (atcPriceBtn) {
          atcPriceBtn.innerText = formatMoney(finalPrice);
        }

        requestAnimationFrame(() => {
          document.dispatchEvent(new CustomEvent('product:price-updated', {
            detail: {
              price: finalPrice,
              variantId: variantId,
              isSubscription: isSubscription
            }
          }));
        });
      };

      // Event Listeners
      tiers.forEach(tier => {
        tier.addEventListener('click', () => {
          tiers.forEach(t => {
            t.classList.remove('is-active');
            t.classList.remove('selected');
          });
          tier.classList.add('is-active');
          tier.classList.add('selected');

          // Check the hidden radio button
          const radio = tier.querySelector('input[type="radio"]');
          if (radio) radio.checked = true;

          updateWidgetData();
          
          // Sync Image Gallery
          const imageIndex = tier.dataset.imageIndex;
          if (imageIndex && window.mainSwiper) {
            window.mainSwiper.slideTo(parseInt(imageIndex));
          }
        });
      });

      options.forEach(option => {
        option.addEventListener('click', () => {
          options.forEach(o => o.classList.remove('is-selected'));
          option.classList.add('is-selected');
          updateWidgetData();
        });
      });

      if (freqSelect) {
        freqSelect.addEventListener('change', () => {
          updateWidgetData();
        });
      }

      // Quantity change listener
      const quantityInput = productSection.querySelector('input[name="quantity"]');
      if (quantityInput) {
        quantityInput.addEventListener('change', updateWidgetData);
        quantityInput.addEventListener('input', updateWidgetData);
      }

      // Initial Load
      updateWidgetData();
    });
  };

  document.addEventListener('DOMContentLoaded', initSubWidget);
  document.addEventListener('shopify:section:load', initSubWidget);
})();
